import React from 'react';
import ApprovalMonitorViewContainer from '../../containers/approval_monitoring/ApprovalMonitorViewContainer';

const ApprovalMonitorViewPage = () => {
  return <ApprovalMonitorViewContainer />;
};

export default ApprovalMonitorViewPage;
